import { PAIC_TAB_KEYS } from "constants/peoplePlusAI.constants";
import { TEXT } from "./SbSkillsMapV2.constants";

// ─── Page-specific Text ───────────────────────────────────────────────────────

export const PAGE_TEXT = {
  CHART_TITLE: "Group Skills Map",
  CHART_SUBTITLE: "(Bubble size shows no. of employees that require the skill)",
  SBI_LABEL: "SKILLSBRIDGE READINESS INDEX^ FOR SELECTED GROUP",
  SBI_VALUE: "85%",
  PROFILE_LABEL: "GROUP PROFILE",
};

// ─── Skills Bridger Dropdown ──────────────────────────────────────────────────
// Stable — no runtime deps, defined once at module load.

export const SKILLS_BRIDGER_DROPDOWN_ITEMS = [
  { key: "skills-map", label: TEXT.DROPDOWN_SKILLS_MAP },
];

// ─── Coming Soon Tabs ─────────────────────────────────────────────────────────
// Set used for O(1) membership check in the render condition.

export const COMING_SOON_TABS = new Set([
  PAIC_TAB_KEYS.LEARNING_CATALYST,
  PAIC_TAB_KEYS.TALENT_MOBILITY,
  PAIC_TAB_KEYS.JOBS_LIBRARY,
]);
